// test1773
(1773 && 0);
